import React from "react";

const Members = React.lazy(() => import("./index"));
const UserDeviceDetail = React.lazy(() =>
  import("../UserFeatures/UserDevices/UserDeviceDetail")
);
const InvoiceTemplate = React.lazy(() => import("../invoiceTemplate"));
const MemberDetails = React.lazy(() => import("./MemberDetails"));
const CreateMember = React.lazy(() => import("./CreateMember"));
const CreatePackageBooking = React.lazy(() =>
  import("./PackageBooking/CreatePackageBooking")
);
const CreateInvoice = React.lazy(() =>
  import("./PackageBooking/CreateInvoice")
);
const CreateReceipt = React.lazy(() =>
  import("./PackageBooking/CreateReceipt")
);
const PackageBookingDetail = React.lazy(() =>
  import("./PackageBooking/PackageBookingDetail")
);
const InvoiceReceiptDetail = React.lazy(() =>
  import("./PackageBooking/PackageBookingDetail/InvoiceReceiptDetail")
);
const InvoiceReceiptTemplate = React.lazy(() =>
  import("../invoiceTemplate/InvoiceReceiptTemplate")
);

export const MemberRoutes = [
  { path: "/admin/members", name: "Members", element: <Members /> },
  {
    path: "/admin/members/:id",
    name: "MemberDetails",
    element: <MemberDetails />,
  },
  {
    path: "/admin/members/:id/userDevice/:userDeviceId",
    name: "UserDeviceDetail",
    element: <UserDeviceDetail />,
  },
  {
    path: "/admin/members/create",
    name: "CreateMember",
    element: <CreateMember />,
  },
  {
    path: "/admin/members/update/:id",
    name: "CreateMember",
    element: <CreateMember />,
  },
  {
    path: "/admin/members/:id/addPackageBooking",
    name: "CreatePackageBooking",
    element: <CreatePackageBooking />,
  },
  {
    path: "/admin/members/:id/updatePackage/:packageId",
    name: "CreatePackageBooking",
    element: <CreatePackageBooking />,
  },
  {
    path: "/admin/members/:id/createInvoice/:packageId",
    name: "CreateInvoice",
    element: <CreateInvoice />,
  },
  {
    path: "/admin/members/:id/createInvoiceReceipt/:packageId",
    name: "CreateReceipt",
    element: <CreateReceipt />,
  },
  {
    path: "/admin/members/:id/invoice/:invoiceId",
    name: "CreateInvoice",
    element: <InvoiceTemplate />,
  },
  {
    path: "/admin/members/:id/invoiceReceiptTemplate/:invoiceId",
    name: "InvoiceReceiptTemplate",
    element: <InvoiceReceiptTemplate />,
  },
  {
    path: "/admin/members/:id/packageBooking/:packageId",
    name: "PackageBookingDetail",
    element: <PackageBookingDetail />,
  },
  {
    path: "/admin/members/:id/packageBooking/:packageId/invoiceReceipt/:receiptId",
    name: "InvoiceReceiptDetail",
    element: <InvoiceReceiptDetail />,
  },
];
